import UserQuery from './user'

const full = 'id name mealPlanningNotes active hasCc creditCardInfo invoice clearItemsFromUnclaimedAccounts ' +
  'organizerUserId contactUserId ccEmail copay copayAllowance clubCoversAllFees dailyAllowances ' +
  'churn churnDate churnNotes churnedReason churnedReasonSecondary churnRisk churnRiskNotes ' +
  'deliveryDaysAndTime deliveryNotes deliveryApt deliveryDays deliveryWindow freeDelivery autoOrder ' +
  'assistantIds assistants { id fullName } ' +
  'accountantIds accountants { id fullName } ' +
  'divisionId division { id name } ' +
  'deliveryAddress { formattedAddress } '

const MealClubQuery = {
  full: full,
  withMembers: `${full} memberships { startDate endDate active user { ${UserQuery.userManagement} } }`,
}

export default MealClubQuery
